"use strict";
exports.__esModule = true;
exports.GdcMetadataObject = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var values_1 = tslib_1.__importDefault(require("lodash/fp/values"));
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var flow_1 = tslib_1.__importDefault(require("lodash/flow"));
/**
 * @public
 */
var GdcMetadataObject;
(function (GdcMetadataObject) {
    function unwrapMetadataObject(object) {
        return flow_1["default"](values_1["default"], first_1["default"])(object);
    }
    GdcMetadataObject.unwrapMetadataObject = unwrapMetadataObject;
})(GdcMetadataObject = exports.GdcMetadataObject || (exports.GdcMetadataObject = {}));
//# sourceMappingURL=GdcMetadataObject.js.map